import LazyLoad from "vanilla-lazyload/dist/lazyload";

export default {
  init() {
    if (document.getElementById("ws-version-select")) {
      document
        .getElementById("ws-version-select")
        .addEventListener("change", function () {
          // Get the value of the selected option
          var selectedDivId = this.value;

          // Loop through all options
          this.querySelectorAll("option").forEach(function (option) {
            var divId = option.value;
            var correspondingDiv = document.getElementById(divId);

            if (option.value !== selectedDivId) {
              correspondingDiv.style.display = "none"; // Hide other divs
            } else {
              correspondingDiv.style.display = "block"; // Show the selected div
            }
          });
        });
    }

    /**
     *  open edit customer name form
     */
    $(".workshop-archive__customer-edit--open-form").on("click", function (e) {
      formExpander($(this));
      e.stopPropagation();
    });

    /**
     * close edit customer name form
     */
    $(".workshop-archive__customer-edit--close-form").on("click", function (e) {
      formExpander($(this));
      e.stopPropagation();
    });

    /**
     * delete customer workshops
     */
    $(".workshop-archive__customer-delete").on("click", function (e) {
      let customer_name = $(this)
        .closest(".workshops-archive__customer")
        .data("customer-name");
      let deleteWs = confirm(
        'Är du säker på att du vill ta bort "' +
          customer_name +
          '" och tillhörande workshops?'
      );

      if (!deleteWs) {
        e.preventDefault();
        return false;
      }
      e.stopPropagation();
    });

    // /**
    //  * show the create customer form
    //  */
    // $('.js-workshop-archive__btn-create-customer').on('click', function () {
    //   $('.workshop-archive_header-create-customer-form').toggleClass('workshop-archive_header-create-customer-form--active');
    // });

    /**
     * filters workshop in archive listing
     */
    $("#workshop_archive__search-filter-input").on("keyup", function (e) {
      var value = $(this)
        .val()
        .toLowerCase()
        .replace(new RegExp(" ", "g"), "-");
      if (value !== "") {
        $(".workshops-archive__customer").hide();
        $(
          ".workshops-archive__customer[data-customer-name*=" + value + "]"
        ).filter(function () {
          $(this).show();
        });
      } else {
        $(".workshops-archive__customer[data-customer-name]").show();
      }
      e.preventDefault();
    });

    /**
     *
     * @param {object} $button
     */
    function formExpander($button) {
      let children = $button.attr("aria-controls");
      let id = children.substring(children.lastIndexOf("-") + 1);

      if ($button.attr("aria-expanded") === "false") {
        $('button[aria-controls="' + children + '"]').attr(
          "aria-expanded",
          true
        );
        $(
          '.workshops-archive__accordion[data-target="#workshop-' + id + '"]'
        ).addClass("workshops-archive__accordion--form-active");
        $("#" + children).toggleClass("show");
      } else {
        $('button[aria-controls="' + children + '"]').attr(
          "aria-expanded",
          false
        );
        $(
          '.workshops-archive__accordion[data-target="#workshop-' + id + '"]'
        ).removeClass("workshops-archive__accordion--form-active");
        $("#" + children).toggleClass("show");
      }
    }

    /**
     *
     */
    var copy_link_trigger = document.querySelectorAll(
      "button[data-mtg-copy-link-trigger]"
    );

    if (copy_link_trigger) {
      for (let i = 0; i < copy_link_trigger.length; i++) {
        copy_link_trigger[i].addEventListener("click", function (e) {
          e.stopPropagation();

          // e = e || window.event;
          // var target = e.target || e.srcElement;

          // Remove the selections - NOTE: Should use
          // removeRange(range) when it is supported
          window.getSelection().removeAllRanges();

          // Select the email link anchor text
          var targetRef = this.getAttribute("data-copy");
          var link_value_elm = "";

          if (targetRef) {
            link_value_elm = document.querySelector("#" + targetRef);
            console.log(link_value_elm);
          } else {
            link_value_elm = document.querySelector("#mtg-copy-link-value");
          }

          var range = document.createRange();
          range.selectNode(link_value_elm);
          window.getSelection().addRange(range);

          try {
            // Now that we've selected the anchor text, execute the copy command
            var successful = document.execCommand("copy");

            var className;
            var msg;

            if (successful) {
              className = "workshop-copy-result-popup-message";
              msg = "Länk färdig att klistras in";
            } else {
              className = "workshop-copy-result-popup-message";
              msg = "Länk behöver kopieras manuellt";
            }

            var $copyEl = $("<div>", { class: className });
            var $copyElInner = $("<span>", { text: msg });

            $copyElInner.appendTo($copyEl);

            $("body").append($copyEl);
            $copyEl.fadeIn("fast");

            setTimeout(function () {
              $copyEl.fadeOut("slow", function () {
                $copyEl.remove();
              });
            }, 5000);
          } catch (err) {
            $copyEl = $("<div>", { class: "copy-fail" });
            $copyElInner = $("<span>", {
              text: "Länk behöver kopieras manuellt",
            });

            $copyElInner.appendTo($copyEl);
            $("body").append($copyEl);

            $copyEl.fadeIn("fast");

            setTimeout(function () {
              $copyEl.fadeOut("slow", function () {
                $(".copy-fail").remove();
              });
            }, 5000);
          }

          e.preventDefault();
        });
      }
    }

    /**
     * Autoexpands textareas when writing inside them
     */
    var textAreas = [].slice.call(document.querySelectorAll("textarea"));
    var minHeight = 120;

    /**
     *
     * @param {array} textAreas
     */
    function expandTextareaWriting(textAreas) {
      textAreas.forEach(function (el) {
        el.addEventListener("input", function () {
          adjustHeight(el, minHeight);
        });
      });
    }

    /**
     *
     * @param {object} el
     * @param {int} minHeight
     */
    function adjustHeight(el, minHeight) {
      var outerHeight = parseInt(window.getComputedStyle(el).height, 10);
      var diff = outerHeight - el.clientHeight;
      el.style.height = 0;
      el.style.height = Math.max(minHeight, el.scrollHeight + diff) + "px";
    }

    /**
     *
     * @param {array} textAreas
     */
    function closeAllTextarea(textAreas) {
      textAreas.forEach(function (el) {
        el.style.height = minHeight + "px";
        el.style.overflowY = "scroll";
        $(window).off("resize");
      });
    }

    /**
     *
     * @param {array} textAreas
     */
    function expandAllTextarea(textAreas) {
      textAreas.forEach(function (el) {
        el.style.overflowY = "hidden";
        $(window).on("resize", function () {
          adjustHeight(el, minHeight);
        });
        adjustHeight(el, minHeight);
      });
    }

    /**
     *
     */
    if (textAreas.length >= 1) {
      expandTextareaWriting(textAreas);

      $("#textarea-expand").on("click", function () {
        expandAllTextarea(textAreas);
        $("#textarea-shrink").prop("disabled", false);
        $(this).prop("disabled", true);
      });

      $("#textarea-shrink").on("click", function () {
        closeAllTextarea(textAreas);
        $("#textarea-expand").prop("disabled", false);
        $(this).prop("disabled", true);
      });
    }

    /**
     * adds table row in workshops
     */
    $("#js-add-table-row").on("click", function (event) {
      event.preventDefault();
      var $table_rows = $(".table-workshop").find("tbody").find(".hidden");
      if ($table_rows.length == 0) {
        $(this).hide();
      } else {
        $table_rows.first("hidden").show();
        $table_rows.first("hidden").removeClass("hidden");
      }
    });

    // if all talbe rows are hidden we trigger a click to show one
    if ($(".table-workshop").find("tbody").find(".hidden").length == 10) {
      $("#js-add-table-row").trigger("click");
    }

    /**
     * table header popup
     */
    $(".table-header-popup__button-open").on("click", function (event) {
      event.preventDefault();
      $(this).hide();
      $(this).siblings(".table-header-popup__modal").show();
      $(this).parent().find(".table-header-popup__button-close").show();
    });

    $(".table-header-popup__button-close").on("click", function (event) {
      event.preventDefault();
      $(this).hide();
      $(this).siblings(".table-header-popup__modal").hide();
      $(this).parent().find(".table-header-popup__button-open").show();
    });

    /**
     * lazyload
     */
    new LazyLoad({
      elements_selector: "[data-ec-do-lazy-load]",
      use_native: false,
      class_loaded: "lazy-loaded",
      callback_loaded: function (el) {
        let closest = el.closest(".lazy-load-wrapper");
        if (closest) {
          closest.classList.add("lazy-loaded-wrapper");
        }
      },
    });

    /**
     * Expand/Minimize textarea
     */
    $(".workshop-form__expand-textarea").on("click", function (event) {
      event.preventDefault(); // Prevent form submission
      var textareas = document.querySelectorAll("textarea");
      var maxHeight = 0;
      textareas.forEach(function (textarea) {
        textarea.style.height = "auto";
        if (textarea.scrollHeight > maxHeight) {
          maxHeight = textarea.scrollHeight;
        }
      });
      textareas.forEach(function (textarea) {
        textarea.style.height = maxHeight + "px";
      });
    });

    $(".workshop-form__minimize-textarea").on("click", function (event) {
      event.preventDefault(); // Prevent form submission
      var textareas = document.querySelectorAll("textarea");
      textareas.forEach(function (textarea) {
        textarea.style.height = "auto";
        textarea.rows = 8; // Set the rows attribute to 8
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

jQuery(document).ready(function () {
  let mtg2000_body_elm = jQuery("body");

  jQuery(
    ".workshops-archive__list-item-controlpanel-dropdown-menu--results a:first-of-type"
  ).on("click", function (event) {
    let $customer_elm = jQuery(this).parents(".workshops-archive__customer");

    if (
      $customer_elm &&
      $customer_elm.attr("data-data-collected") &&
      $customer_elm.attr("data-data-collected") != 1
    ) {
      alert(window.data_collection_short_info_on_illegal_show_info);
      event.preventDefault();
    }
  });

  if (mtg2000_body_elm.attr("data-mtg-data-collection-lockable") != 1) {
    jQuery(".acf-field-2409241443a-2401101429z").remove();
    jQuery(".acf-field-2409241443a-2401101429q").remove();
  } else {
    if (
      mtg2000_body_elm.attr("data-mtg-data-collection-question-answered") == 0
    ) {
      jQuery(".workshop-form-result-btn").on("click", function (event) {
        alert(window.data_collection_short_info_on_illegal_show_info);
        event.preventDefault();
      });

      jQuery(".acf-form-submit").on("click", function (event) {
        if (
          jQuery(".af-field-data-collection-choice").css("display") !==
            "none" &&
          jQuery('[name="acf[field_2409241443a_2401101429q]"]:checked')
            .length === 0
        ) {
          alert(window.data_collection_short_info_on_illegal_save);
          event.preventDefault();
        }
      });
    }
  }
});
